<template>
<div>
  <!-- <Header/> -->
  <Welcome/>
  <AboutUs/>
  <Onlinesessions/>
  <OnlineCourse/>
  <Benefits/>
  <Subscribe/>
  <Teachers/>
  <BecomeTeacher />
  <Testimonials/>
  <Accomplishments/>
  <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from "../components/Home/Welcome.vue"
import AboutUs from "../components/Home/AboutUs.vue"
import Onlinesessions from "../components/Home/Onlinesessions.vue"
import OnlineCourse from "../components/Home/OnlineCourse.vue"
import Benefits from "../components/Home/Benefits.vue"
import Subscribe from "../components/Home/Subscribe.vue"
import Teachers from "../components/Home/Teachers.vue"
import BecomeTeacher from "../components/Home/BecomeTeacher.vue"
import Testimonials from "../components/Home/Testimonials.vue"
import Accomplishments from "../components/Home/Accomplishments.vue"
import Footer from "../components/Partials/Footer.vue"
// import Header from "../components/Partials/Header.vue"
export default {
  name: 'Home',
  components:{Welcome, AboutUs, Onlinesessions, OnlineCourse, Benefits, Subscribe, Teachers, BecomeTeacher,Footer, Testimonials,Accomplishments},

mounted () {
  window.scrollTo(0, 0)
  
}
}
</script>

<style scoped>
/* body {
  background-color: coral;
} */



</style>
